
export const formControls = (): void => {
  const contactFormElement = document.querySelector('.js-contactForm') as HTMLElement

  if (!contactFormElement) {
    return
  }

  const allIInputs = contactFormElement.querySelectorAll('.js-contactForm-inputWrapper') as unknown as HTMLElement[]

  allIInputs.forEach((inputWrapper: HTMLElement) => {
    const inputElement = inputWrapper.querySelector('input, textarea') as HTMLInputElement
    const labelElement = inputWrapper.querySelector('label') as HTMLLabelElement

    inputElement.addEventListener('focus', () => {
      processInput(inputElement, labelElement, true)
    })

    inputElement.addEventListener('blur', () => {
      processInput(inputElement, labelElement)
    })

    processInput(inputElement, labelElement)
  })
}

const processInput = (input: HTMLInputElement, label: HTMLLabelElement, forceHide = false) => {
  if (input.value.length > 0 || forceHide) {
    label.style.display = 'none'
  } else {
    label.style.display = ''
  }
}
